import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Sheet } from "lucide-react";

interface IUnderlaymentType {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function UnderlaymentType(props: IUnderlaymentType) {
    const { value, onChange, loading } = { ...props };
    const [underlaymentType, setUnderlaymentType] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setUnderlaymentType(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setUnderlaymentType(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Underlayment Type
            </Typography>

            <Select
                placeholder="Select underlayment type"
                value={underlaymentType}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Sheet size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="Felt 15 lb">Felt 15 lb</Option>
                <Option value="Synthetic">Synthetic</Option>
            </Select>
        </Box>
    );
}
